import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { InduccionEstado } from 'src/app/models/common/enumModel';
import { SearchResultModel } from 'src/app/models/common/SearchResultModel';
import { FilterInduccionModel } from 'src/app/models/induccion/FilterInduccionModel';
import { InduccionResultadoBusquedaModel } from 'src/app/models/induccion/InduccionResultadoBusquedaModel';
import { InduccionResultadoModel, InduccionResultadosModel } from 'src/app/models/induccion/InduccionResultadoModel';
import { IFilterInduccionModel } from 'src/app/models/interfaces/induccion/IFilterInduccionModel';
import { IInduccionResultadoBusquedaModel } from 'src/app/models/queries/inducciones/interfaces/IInduccionResultadoBusquedaModel';
import { ParametroModel } from 'src/app/models/parametros/ParametroModel';
import { InduccionService } from 'src/app/services/induccion/induccion.service';
import { ParametroService } from 'src/app/services/parametros/parametro.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import * as fileSaver from 'file-saver';
import { MatDialog } from '@angular/material/dialog';
import { InduccionResultadosDialogComponent } from '../../induccion-resultados-dialog/induccion-resultados-dialog.component';
import { CompaniaModel } from 'src/app/models/compania/CompaniaModel';
import { StorageService } from 'src/app/services/storage/storage.service';

@Component({
  selector: 'app-induccion-registro-resultados-lista',
  templateUrl: './induccion-registro-resultados-lista.component.html',
  styleUrls: ['./induccion-registro-resultados-lista.component.css']
})
export class InduccionRegistroResultadosListaComponent implements OnInit {
  modelFilter: IFilterInduccionModel;
  modelListaInducciones: IInduccionResultadoBusquedaModel[];
  paramsEstados!: ParametroModel[];

  checkTodosAprobados: boolean = false;
  checkTodosObservados: boolean = false;

  resultsLength = 0;
  currentPage = 0;
  @ViewChild('paginator') paginator!: MatPaginator;

  displayedColumns: string[] = [
    'codigo_solicitud',
    'compania',
    'trabajador',
    'nroDocumentoIdentidad',
    'contratista',
    'sede',
    'solicitante',
    'fecha_induccion',
    // 'estado',    
    'aprobado',
    'desaprobado'
    // 'acciones',
  ];

  constructor(
    private storage: StorageService,
    private induccionService: InduccionService,
    private parametroService: ParametroService,
    public dialog: MatDialog,
    private confirmDialogService: ConfirmDialogService,
  ) {
    this.modelFilter = new FilterInduccionModel();
    this.modelFilter.pageSize = 30;
    this.modelFilter.idEstado = InduccionEstado.PROGRAMADO;
    this.modelListaInducciones = new Array<InduccionResultadoBusquedaModel>();
    let usuario = this.storage.getCurrentUser();
    this.modelFilter.idCompania = usuario.companiaDefault.idCompania;
  }

  ngOnInit(): void {
    this.parametroService
      .getDetalles(5)
      .subscribe((data) => {
        this.paramsEstados = data.items;
      });
    this.induccionService
      .getList(this.modelFilter)
      .subscribe((data: SearchResultModel<IInduccionResultadoBusquedaModel[]>) => {
        this.modelListaInducciones = data.items;
        this.resultsLength = data.total;
      });
  }

  getPaginatorData(event: any) {
    this.modelFilter.page = event.pageIndex + 1;
    this.modelFilter.pageSize = event.pageSize;
    this.induccionService
      .getList(this.modelFilter)
      .subscribe((data: SearchResultModel<IInduccionResultadoBusquedaModel[]>) => {
        this.modelListaInducciones = data.items;
        this.resultsLength = data.total;
      });
  }

  search() {
    //this.paginator.pageIndex = 0;
    this.modelFilter.page = 1;
    // this.model.pageSize = this.paginator.pageSize;
    this.induccionService
      .getList(this.modelFilter)
      .subscribe((data: SearchResultModel<IInduccionResultadoBusquedaModel[]>) => {
        this.modelListaInducciones = data.items;
        this.resultsLength = data.total;
        this.currentPage = 0;
        this.paginator.firstPage();
      });
  }

  registrarResultados() {
    let resultados = new InduccionResultadosModel();
    resultados.listaInducciones = this.modelListaInducciones.filter(p => p.aprobado || p.desaprobado).map((p) => {
      let resultado = new InduccionResultadoModel();
      resultado.aprobado = p.aprobado;
      resultado.desaprobado = p.desaprobado;
      resultado.idInduccion = p.idInduccion;
      return resultado;
    });
    const dialogRef = this.dialog.open(InduccionResultadosDialogComponent, {
      width: '500px',
      // data: { name: this.name, animal: this.animal}
      data: resultados
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result)
        this.search();
    });
  }

  addDays(currentDate: Date, days: number): Date {
    currentDate.setDate(currentDate.getDate() + days);
    return currentDate;
  }

  changeAprobado(element: IInduccionResultadoBusquedaModel) {
    if (element.aprobado)
      element.desaprobado = false;
  }

  changeDesaprobado(element: IInduccionResultadoBusquedaModel) {
    // element.aprobado = !element.observado;
    if (element.desaprobado)
      element.aprobado = false;
  }

  changeAprobadoAll(item: any) {
    console.log(item);
    if (item.checked) {
      this.checkTodosObservados = false;
      this.modelListaInducciones.forEach(element => {
        element.desaprobado = false
        element.aprobado = item.checked;
      });
    }
    else {
      this.modelListaInducciones.forEach(element => {
        element.aprobado = item.checked;
      });
    }
  }

  changeDesaprobadoAll(item: any) {
    console.log(item);

    if (item.checked) {
      this.checkTodosAprobados = false;
      this.modelListaInducciones.forEach(element => {
        element.aprobado = false;
        element.desaprobado = item.checked;
      });
    }
    else {
      this.modelListaInducciones.forEach(element => {
        element.desaprobado = item.checked;
      });
    }
  }

  esInvalido(): boolean {
    return this.modelListaInducciones.filter(p => p.aprobado || p.desaprobado).length == 0;
  }

  export() {
    //this.paginator.pageIndex = 0;
    this.modelFilter.page = 1;
    // this.model.pageSize = this.paginator.pageSize;
    this.induccionService.getListToExport(this.modelFilter).subscribe(
      (data) => {
        // console.log(data.headers.get('content-disposition'));
        // console.log(data.headers);
        let blob: any = new Blob([data], { type: 'text/json; charset=utf-8' });
        const url = window.URL.createObjectURL(blob);

        //window.open(url);
        //window.location.href = response.url;
        fileSaver.saveAs(blob, `induccion-${Date.now()}.xlsx`);

        //  this.createImageFromBlob(data);
        //  this.isImageLoading = false;
      },
      (error) => {
        //  this.isImageLoading = false;
        //  console.log(error);
      }
    );
  }
}
